import {
    MEMBER_PERSONAL_ROOM_URL,
    CREATE_MEMBER_PERSONAL_ROOM_URL,
    UPDATE_MEMBER_PERSONAL_ROOM_URL,
    DELETE_MEMBER_PERSONAL_ROOM_URL
} from './constants';

import {getAxios, formDataToRequestParams} from './axios'
import {responseResolveInterceptor} from './interceptors';
import {addAuthTokenData} from './member';

export function getMemberPersonalRoom(params = {}) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: MEMBER_PERSONAL_ROOM_URL,
        method: 'get',
        params: {...addAuthTokenData(params)}
    });
}

export function createMemberPersonalRoom(data = {}) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: CREATE_MEMBER_PERSONAL_ROOM_URL,
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}

export function activateMemberPersonalRoom(roomid) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: UPDATE_MEMBER_PERSONAL_ROOM_URL,
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({action: 'activate', roomid}))
    });
}

export function deactivateMemberPersonalRoom(roomid) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: UPDATE_MEMBER_PERSONAL_ROOM_URL,
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({action: 'deactivate', roomid}))
    });
}

export function updateMemberPersonalRoom(data = {}) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: UPDATE_MEMBER_PERSONAL_ROOM_URL,
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({action: 'update', ...data}))
    });
}

export function deleteMemberPersonalRoom(roomid) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: DELETE_MEMBER_PERSONAL_ROOM_URL,
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({roomid}))
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberPersonalRooms.js